import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './orders.actions.js';
import getters from './orders.getters.js';
import mutations from './orders.mutations.js';
import state from './orders.state.js';

BaseStore.registerModule('orders', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('orders');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
